const tipoFlujos = [
  { id: true, label: 'Ingreso' },
  { id: false, label: 'Egreso' },
];

export default tipoFlujos;
